import { useState } from "react";
import { get } from "../../lib/sessionClient";

const useDownloadFile = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState("");

  const generateFile = async (apiEndPoint, downloadFileName) => {
    setIsLoaded(true);
    try {
      const response = await get(apiEndPoint, {
        responseType: "blob",
      });
      saveExcelFile(response.data, downloadFileName);
      error && setError("");
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Something went wrong";
      setError(message);
    } finally {
      setIsLoaded(false);
    }
  };

  const saveExcelFile = (blob, downloadFileName) => {
    if (!blob || blob.size === 0) {
      console.error("Empty file received");
      return;
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = downloadFileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  return {
    isLoaded,
    error,
    generateFile,
    setIsLoaded,
    setError,
  };
};

export default useDownloadFile;
